import {
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import {Avatar, Button, ConfigProvider, Divider, Layout, Menu, Skeleton, theme} from 'antd';
import {Content, Header} from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import {jwtDecode} from 'jwt-decode';
import PropTypes from 'prop-types';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import {FaHandHoldingMedical} from 'react-icons/fa';
import {FaFileInvoiceDollar, FaUserDoctor} from 'react-icons/fa6';
import {GiMedicines} from 'react-icons/gi';
import {MdOutlineDashboard, MdOutlineInventory} from 'react-icons/md';
import {useDispatch, useSelector} from 'react-redux';
import {NavLink, Route, Routes, useLocation, useNavigate} from 'react-router-dom';

import Collapselogo from '../../Assets/CollapsedLogo.png';
import logo from '../../Assets/logo.png';
import {RqUserLookupById} from '../../ReactQuery/apis';
import {logoutStart} from '../../Redux/authAction';
import PatientBillScreen from '../../ScreenComponents/AdminScreens/PatientsBill/PatientBillScreen';

import {AppoinmentScreen} from './AppoinmentScreen';
import DrawerMenu from './DrawerMenu/DrawerMenu';
import {MainDashboard} from './MainDashboard';
import {MedicineManagementScreen} from './MedicineScreen';
import {PatientDetailsScreen} from './PatientsScreen';
import {ProfileScreen} from './ProfileScreen';
import {Employee} from './UserRegistration/Employee';
import PatientScreen from './UserRegistration/Patient/Patient';

function getItem(label, key, icon, path) {
  return {
    key,
    icon,
    label,
    path,
  };
}

const ComingSoon = ({label}) => (
  <div className={'flex items-center justify-center h-64 text-primary-400 text-lg'}>
    {label} screen coming soon
  </div>
);

ComingSoon.propTypes = {
  label: PropTypes.string.isRequired,
};

const ROLE_CONFIG = {
  ADMIN: {
    menu: [
      getItem(
        'Dashboard',
        'dashboard',
        <MdOutlineDashboard className={'!text-[22px]'} />,
        'dashboard',
      ),
      getItem(
        'Appointments',
        'appointments',
        <MdOutlineInventory className={'!text-[22px]'} />,
        'appointments',
      ),
      getItem(
        'Patients',
        'patients',
        <FaHandHoldingMedical className={'!text-[22px]'} />,
        'patients',
      ),
      getItem(
        'Doctors',
        'doctors',
        <FaUserDoctor className={'!text-[22px]'} />,
        'doctors',
      ),
      getItem(
        'Medicine',
        'medicine',
        <GiMedicines className={'!text-[22px]'} />,
        'medicine',
      ),
      getItem(
        'Bill',
        'bill',
        <FaFileInvoiceDollar className={'!text-[22px]'} />,
        'bill',
      ),
    ],

    routes: [
      {
        path: 'dashboard',
        element: <MainDashboard />,
      },
      {
        path: 'appointments',
        element: <AppoinmentScreen />,
      },
      {
        path: 'patients',
        element: <PatientScreen />,
      },
      {
        path: 'doctors',
        element: <Employee />,
      },
      {
        path: 'medicine',
        element: <MedicineManagementScreen />,
      },
      {
        path: 'patients/:id',
        element: <PatientDetailsScreen />,
      },
      {
        path: 'profile',
        element: <ProfileScreen />,
      },
      {
        path: 'bill',
        element: <PatientBillScreen />,
      },
    ],
  },

  RECEPTIONIST: {
    menu: [
      getItem(
        'Dashboard',
        'dashboard',
        <MdOutlineDashboard className={'!text-[22px]'} />,
        'dashboard',
      ),
      getItem(
        'Appointments',
        'appointments',
        <MdOutlineInventory className={'!text-[22px]'} />,
        'appointments',
      ),
      getItem(
        'Patients',
        'patients',
        <FaHandHoldingMedical className={'!text-[22px]'} />,
        'patients',
      ),
      getItem(
        'Doctors',
        'doctors',
        <FaUserDoctor className={'!text-[22px]'} />,
        'doctors',
      ),
      getItem(
        'Medicine',
        'medicine',
        <GiMedicines className={'!text-[22px]'} />,
        'medicine',
      ),
    ],

    routes: [
      {
        path: 'dashboard',
        element: <MainDashboard />,
      },
      {
        path: 'appointments',
        element: <AppoinmentScreen />,
      },
      {
        path: 'patients',
        element: <PatientScreen />,
      },
      {
        path: 'doctors',
        element: <Employee />,
      },
      {
        path: 'medicine',
        element: <MedicineManagementScreen />,
      },
      {
        path: 'patients/:id',
        element: <PatientDetailsScreen />,
      },
      {
        path: 'profile',
        element: <ProfileScreen />,
      },
    ],
  },

  DOCTOR: {
    menu: [
      getItem(
        'Dashboard',
        'dashboard',
        <MdOutlineDashboard className={'!text-[22px]'} />,
        'dashboard',
      ),
      getItem(
        'Appointments',
        'appointments',
        <MdOutlineInventory className={'!text-[22px]'} />,
        'appointments',
      ),
      getItem(
        'Patients',
        'patients',
        <FaHandHoldingMedical className={'!text-[22px]'} />,
        'patients',
      ),
    ],

    routes: [
      {
        path: 'dashboard',
        element: <MainDashboard />,
      },
      {
        path: 'appointments',
        element: <AppoinmentScreen />,
      },
      {
        path: 'patients',
        element: <PatientScreen />,
      },
      {
        path: 'patients/:id',
        element: <PatientDetailsScreen />,
      },
      {
        path: 'profile',
        element: <ProfileScreen />,
      },
    ],
  },

  THERAPIST: {
    menu: [
      getItem(
        'Dashboard',
        'dashboard',
        <MdOutlineDashboard className={'!text-[22px]'} />,
        'dashboard',
      ),
      getItem(
        'Appointments',
        'appointments',
        <MdOutlineInventory className={'!text-[22px]'} />,
        'appointments',
      ),
      getItem(
        'Patients',
        'patients',
        <FaHandHoldingMedical className={'!text-[22px]'} />,
        'patients',
      ),
    ],

    routes: [
      {
        path: 'dashboard',
        element: <MainDashboard />,
      },
      {
        path: 'appointments',
        element: <AppoinmentScreen />,
      },
      {
        path: 'patients',
        element: <PatientScreen />,
      },
      {
        path: 'patients/:id',
        element: <PatientDetailsScreen />,
      },
      {
        path: 'profile',
        element: <ProfileScreen />,
      },
    ],
  },
};

const AdminDashboardScreen = () => {
  const [collapsed, setCollapsed] = useState(false);

  const role = useSelector(state => state.auth?.user?.role);
  const auth = useSelector(state => state.auth);

  const {loggedIn} = auth;
  const token = auth?.tokenData;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const skipRedirectRef = useRef(false);

  /**
   * Decode JWT
   */
  let decodedToken = null;
  let id = null;

  if (token) {
    try {
      decodedToken = jwtDecode(token);

      id =
        decodedToken?.userId ||
        decodedToken?.employeeId ||
        decodedToken?.id;
    } catch (error) {
      console.error('Unable to decode authentication token:', error);
      decodedToken = null;
      id = null;
    }
  }

  /**
   * Fetch logged-in user's profile
   */
  const {
    data: profileDetails,
    isLoading: profileLoading,
  } = RqUserLookupById(id, token, {
    enabled: loggedIn && !!id && !!token,
  });

  /**
   * Role configuration
   */
  const config = ROLE_CONFIG[role];

  const menuItems = config?.menu || [];
  const routes = config?.routes || [];

  const basePath = role ? `/${role.toLowerCase()}` : '';

  /**
   * Logout / authentication guard
   */
  useEffect(() => {
    if (!auth.loggedIn && !skipRedirectRef.current) {
      dispatch(
        logoutStart({
          showLoginModal: true,
        }),
      );
    }
  }, [auth.loggedIn, dispatch]);

  /**
   * Current date
   */
  const today = new Date();

  const day = today.toLocaleDateString('en-US', {
    weekday: 'long',
  });

  const date = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  /**
   * Ant Design theme
   */
  const {
    token: {
      colorBgContainer,
      borderRadiusLG,
    },
  } = theme.useToken();

  /**
   * Logout handler
   */
  const handleLogout = () => {
    skipRedirectRef.current = true;

    dispatch(logoutStart());

    navigate('/');
  };

  /**
   * User display information
   */
  const displayName = profileDetails?.fullName || '';

  const initial =
    displayName?.[0]?.toUpperCase() || <UsergroupAddOutlined />;

  /**
   * Ant Design Menu items
   *
   * IMPORTANT:
   * We are using the `items` API instead of <Menu.Item>.
   *
   * This fixes:
   * [antd: Menu] `children` is deprecated.
   *
   * We also use `type: 'divider'` instead of putting
   * <Divider /> directly inside <Menu>.
   */
  const menuItemsForAntd = useMemo(() => {
    const items = [];

    menuItems.forEach((item, index) => {
      const fullPath = `${basePath}/${item.path}`;

      items.push({
        key: fullPath,
        icon: item.icon,

        className:
          '!text-gold hover:!bg-primary-700 font-normal bg-primary-950 text-lg',

        label: (
          <p className={'w-full flex justify-start pl-3'}>
            {item.label}
          </p>
        ),

        onClick: () => {
          navigate(fullPath);
        },
      });

      /**
       * Add divider between items.
       *
       * Do NOT use <Divider /> directly inside <Menu>.
       */
      if (index !== menuItems.length - 1) {
        items.push({
          type: 'divider',
        });
      }
    });

    return items;
  }, [menuItems, basePath, navigate]);

  /**
   * Determine which menu item should be selected.
   *
   * This also handles:
   *
   * /admin/patients
   * /admin/patients/123
   *
   * so "Patients" remains selected on the patient details page.
   */
  const selectedMenuKey = useMemo(() => {
    const matchingItem = menuItems.find(item => {
      const fullPath = `${basePath}/${item.path}`;

      return (
        location.pathname === fullPath ||
        location.pathname.startsWith(`${fullPath}/`)
      );
    });

    return matchingItem
      ? [`${basePath}/${matchingItem.path}`]
      : [];
  }, [menuItems, basePath, location.pathname]);

  return (
    <div>
      <Layout className={'h-full'}>

        {/* =====================================================
            DESKTOP SIDEBAR
        ====================================================== */}
        <Sider
          width={230}
          trigger={null}
          className={'h-screen overflow-hidden lg:block hidden sticky top-0 left-0 bg-primary-950 text-white shadow-right shadow'}
          collapsible
          collapsed={collapsed}
        >
          <div className={'demo-logo-vertical'} />

          {/* Logo */}
          <div className={'flex items-center justify-center h-20 text-2xl my-2'}>
            {collapsed ? (
              <img
                src={Collapselogo}
                alt={'Logo'}
                className={'md:h-14 h-8'}
              />
            ) : (
              <img
                src={logo}
                alt={'Logo'}
                className={'md:h-20 h-8'}
              />
            )}
          </div>

          <Divider className={'mb-4 mt-2 bg-primary-700'} />

          <div className={'flex flex-col h-[calc(100vh-120px)] justify-between'}>

            {/* =================================================
                MENU
            ================================================== */}
            <div className={'flex-1 overflow-y-auto overflow-x-hidden'}>

              <Menu
                mode={'inline'}
                className={'bg-primary-950 mt-2'}
                selectedKeys={selectedMenuKey}
                items={menuItemsForAntd}
              />

            </div>

            {/* =================================================
                PROFILE + LOGOUT
            ================================================== */}
            <div className={'border-t pb-2 border-primary-700 justify-center pt-0'}>

              {/* Profile */}
              <NavLink
                className={'w-full px-4 py-3 flex justify-center items-center gap-3'}
                to={`${basePath}/profile`}
              >
                <Avatar
                  size={42}
                  className={'bg-gold shrink-0 text-primary-950 text-xl'}
                >
                  {initial}
                </Avatar>

                {!collapsed && (
                  <div className={'text-left overflow-hidden flex-1'}>

                    {profileLoading ? (
                      <>
                        <Skeleton.Input
                          active
                          size={'small'}
                          style={{
                            width: 110,
                            marginBottom: 4,
                          }}
                        />

                        <Skeleton.Input
                          active
                          size={'small'}
                          style={{
                            width: 70,
                            display: 'block',
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <h4 className={'text-xl text-gold font-semibold capitalize truncate m-0'}>
                          {displayName || 'My Profile'}
                        </h4>

                        <p className={'text-gold m-0 capitalize'}>
                          {role?.toLowerCase()}
                        </p>
                      </>
                    )}

                  </div>
                )}
              </NavLink>

              {/* Logout */}
              <Button
                onClick={handleLogout}
                className={
                  collapsed
                    ? 'flex items-center justify-center bg-transparent !border-none w-full hover:!bg-primary-950 hover:!text-primary-100 text-base text-primary-400 mb-4'
                    : 'flex items-center gap-2 bg-transparent !border-none w-full hover:!bg-primary-950 hover:!text-primary-100 text-lg text-primary-300 px-4 py-2 mb-4'
                }
              >
                <LogoutOutlined />

                {!collapsed && (
                  <span>
                    Logout
                  </span>
                )}
              </Button>

            </div>
          </div>
        </Sider>

        {/* =====================================================
            MAIN LAYOUT
        ====================================================== */}
        <Layout className={'bg-white'}>

          {/* =================================================
              HEADER
          ================================================== */}
          <Header
            className={'sticky top-0 z-50 !bg-primary-50 flex items-center justify-between px-4 shadow-inner'}
            style={{
              background: colorBgContainer,
              height: 64,
            }}
          >

            {/* Desktop sidebar toggle */}
            <Button
              type={'text'}
              icon={
                collapsed
                  ? <MenuUnfoldOutlined />
                  : <MenuFoldOutlined />
              }
              onClick={() => setCollapsed(prev => !prev)}
              className={'text-xl text-primary-700 lg:block hidden'}
            />

            {/* Mobile drawer */}
            <div className={'lg:hidden block'}>
              <DrawerMenu
                items={menuItems.map(item => ({
                  ...item,
                  path: `${basePath}/${item.path}`,
                }))}
              />
            </div>

            {/* Center text */}
            <div>
              <p className={'text-sm font-md font-serif text-gold'}>
                Fertility | Womens Health | Holistic Wellness
              </p>
            </div>

            {/* Date */}
            <div className={'flex items-center gap-3'}>
              <div className={'text-center flex w-full justify-between'}>
                <div className={'text-right'}>
                  <h1 className={'text-sm text-primary-700'}>
                    {day}
                  </h1>

                  <h1 className={'text-sm text-primary-700'}>
                    {date}
                  </h1>
                </div>
              </div>
            </div>

          </Header>

          {/* =================================================
              CONTENT
          ================================================== */}
          <Content
            className={'!bg-primary-50'}
            style={{
              margin: '24px 16px',
              padding: 24,
              minHeight: 280,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: '#d4dadc',
                },
              }}
            >
              <Routes>

                {routes.map(route => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                ))}

              </Routes>
            </ConfigProvider>
          </Content>

        </Layout>
      </Layout>
    </div>
  );
};

export default AdminDashboardScreen;
